import { Col } from "react-bootstrap";
import { images } from "../../../../../../constants";
import { Submodal } from "../.../.../../../../../../../../constants/jsonConstant";
import CloseIcon from '@mui/icons-material/Close';
import "./chatsubbox.css";
const Chatsubbox = ({setChatsubbox}) => {
  return (
    <>
     
        <Col
          lg="8"
          md="8"
          sm="9"
          xs="9"
          className="b-radius background-white border subbox_absolute  ps-0 pe-0"
        >
          <div className="d-flex">
            <img
              src={images.Profileimg}
              alt=""
              className="ps-2 pt-1 chatboxImg2"
            />{" "}
            <h6 className="mt-2">&nbsp;&nbsp;Alex John</h6>
            <CloseIcon className="icon_f ms-auto mt-2 me-2" onClick={()=>setChatsubbox(false)}/>

          </div>

          <div className="messageArea noscroll">
            {Submodal.map((e) => (
              <Col lg="11" className="leftMessage p-1">
                <h5 className="font-sm" style={{ color: "#3d3bee" }}>
                  {e.time}
                </h5>
                <p className="font-sm">{e.desc}</p>
              </Col>
            ))}
          </div>
          <div className="chatBorderLine"></div>
          <div className=" messageTopLine">
            <div className="d-flex">
              <div className="col-8 ps-0 pe-0 inputMessageArea">
                <div className=" input-focus">
                  <div className="form-group">
                    <textarea
                      className="form-control area_br_none"
                      id="exampleFormControlTextarea1"
                      placeholder="Write message"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="col-4 ps-0 pe-2 d-flex justify-content-end">
                <div className="messageButton">
                  <button className="sm-btn mt-2">Send</button>
                </div>
              </div>
            </div>
          </div>
        </Col>
    
    </>
  );
};

export default Chatsubbox;
